let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c9peD")).then(() => parcelRequire('4yoHz'));